import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "title", "optionalText", "onExit", "onClose", "links", "logoutButton", "logoutButtonProps", "menuLinksProps", "classes"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Children } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { Button } from '../Button';
import HeaderPopup from '../HeaderPopup';
import MenuLinks from '../MenuLinks';
import styles from './ProfileInfo.css';
var cx = classNames.bind(styles);

var ProfileInfo = function ProfileInfo(_ref) {
  var _menuLinksProps$class;

  var children = _ref.children,
      title = _ref.title,
      optionalText = _ref.optionalText,
      onExit = _ref.onExit,
      onClose = _ref.onClose,
      links = _ref.links,
      _ref$logoutButton = _ref.logoutButton,
      logoutButton = _ref$logoutButton === void 0 ? 'Выйти' : _ref$logoutButton,
      logoutButtonProps = _ref.logoutButtonProps,
      menuLinksProps = _ref.menuLinksProps,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      rest = _objectWithoutProperties(_ref, _excluded);

  var headerPopupProps = {
    title: title,
    optionalText: optionalText,
    onClose: onClose
  };

  var handleExitClick = function handleExitClick() {
    if (onExit) {
      onExit();
    }

    if (onClose) {
      onClose();
    }
  };

  return /*#__PURE__*/React.createElement(HeaderPopup, _extends({}, headerPopupProps, rest), /*#__PURE__*/React.createElement("div", {
    className: cx('inner', {
      inner_without_status_block: !children
    }, classes.inner)
  }, children && /*#__PURE__*/React.createElement("div", {
    className: cx('priority_list', classes.priorityList)
  }, Children.map(children, function (child) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('priority_item', classes.priorityItem)
    }, child);
  })), links && /*#__PURE__*/React.createElement("div", {
    className: cx('links', classes.links)
  }, /*#__PURE__*/React.createElement(MenuLinks, _extends({}, menuLinksProps, {
    links: links,
    classes: _objectSpread(_objectSpread({}, menuLinksProps === null || menuLinksProps === void 0 ? void 0 : menuLinksProps.classes), {}, {
      link: cx('link', menuLinksProps === null || menuLinksProps === void 0 ? void 0 : (_menuLinksProps$class = menuLinksProps.classes) === null || _menuLinksProps$class === void 0 ? void 0 : _menuLinksProps$class.link)
    })
  })))), logoutButton && /*#__PURE__*/React.createElement("div", {
    className: cx('logout', {
      logout_without_links: !links
    }, classes.logout)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('logout_button', classes.logoutButton)
  }, /*#__PURE__*/React.createElement(Button, _extends({
    theme: "outline",
    onClick: handleExitClick,
    block: true
  }, logoutButtonProps), logoutButton))));
};

export default ProfileInfo;